<bw-action-card-legacy (ctaClicked)="navigate()" [cardConfig]="actionCardConfig"></bw-action-card-legacy>
